import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {CustomerOverViewService} from '~features/customer-overview/customer-overview.service';
import {PageReservationsListComponent} from './page-reservations-list/page-reservations-list.component';
import {Club, Customer, SidebarOptions} from '~core/models';
import {CustomerService, NavigationService, ScreenSizeService, StorageService} from '~core/services';
import {SidebarService} from '~core/components/sidebar/sidebar.service';

/**
 * This component is the page that views only the merchandising
 */
@UntilDestroy()
@Component({
  selector: 'app-ticketing-page',
  templateUrl: './ticketing-page.component.html',
  styleUrls: ['../../customer-overview.component.scss']
})
export class TicketingPageComponent implements AfterViewInit, OnDestroy {
  public currentlyOpened: string = 'invoices';
  public customer: Customer;
  public childrenLoaded: boolean = false;
  public selectedClub: Club;

  @ViewChild(PageReservationsListComponent) public reservationsComponent: PageReservationsListComponent;
  constructor(
    public customerOverviewService: CustomerOverViewService,
    public sidebarService: SidebarService,
    public customerService: CustomerService,
    public route: ActivatedRoute,
    public navigationService: NavigationService,
    private storageService: StorageService,
    private screenSizeService: ScreenSizeService,
  ) {
    if (this.screenSizeService.screenSize === 'desktop') {
      this.sidebarService.setSidebar(new SidebarOptions(true, true));
    } else {
      this.sidebarService.setSidebar(new SidebarOptions(false, true));
    }
    this.navigationService.setCurrentPage('ticketing');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'customerProfile']);
    this.customerService.castSelectedCustomer.pipe(untilDestroyed(this))
      .subscribe((customer: Customer) => this.customer = customer);
    this.storageService.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
  }

  public ngAfterViewInit(): void {
    if (window.history.state.tab) {
      this.setCurrentlyOpened(window.history.state.tab);
    }
    this.childrenLoaded = true;
  }

  public ngOnDestroy(): void {
    this.customerOverviewService.toggleAllModal(false);
  }

  /**
   * Sets the currently opened tab
   */
  public setCurrentlyOpened(tab: string): void {
    this.currentlyOpened = tab;
  }

}
